import { RoutePoint } from "../../../models/routes/routePoint";
import ListItemCard from "../../../components/containers/listItemCard";
import clsx from "clsx";
import RoutePointInfo from "../routePointInfo";
import { Button } from "reactstrap";

const ActivePoint: React.FC<{
    pointClosed: boolean;
    routePoint: RoutePoint;
    onOpenPoint: () => void;
}> = ({ pointClosed, routePoint, onOpenPoint }) => {
    return (
        <ListItemCard className={clsx("border-start border-5", pointClosed ? "border-success" : "border-warning")}>
            <RoutePointInfo routePoint={routePoint} />
            {pointClosed ? (
                <>
                    <div className="mt-2 text-center fw-bold">Закрыт</div>
                    <Button className="w-100 mt-2" color="secondary" size="sm" onClick={onOpenPoint}>
                        Просмотреть
                    </Button>
                </>
            ) : (
                <Button className="w-100 mt-2" color="primary" onClick={onOpenPoint}>
                    Я на месте
                </Button>
            )}
        </ListItemCard>
    );
};
export default ActivePoint;
